import React from "react";
import { Actionable, Button, SheetContainer } from "@bookingcom/bui-react";
import { useUnifiedPriceTagPriceBreakdownController } from "./useUnifiedPriceTagPriceBreakdown.controller";
import { type UnifiedPriceTagPriceBreakdownProps } from "./UnifiedPriceTagPriceBreakdown";
import flights_lve_web_price_strikethrough_alignment from "utils/experiments/pricing/flights_lve_web_price_strikethrough_alignment";
import useRouteName from "hooks/useRouteName";

export const UnifiedPriceTagPriceBreakdownMobile = ({
  priceBreakdownTrigger,
  priceBreakdownTriggerProps,
  priceBreakdownContent,
  priceBreakdownOnOpen = () => {},
  priceBreakdownOnClose = () => {}
}: UnifiedPriceTagPriceBreakdownProps) => {
  const { contentTitle, closeAriaLabel, showPriceBreakdown, setShowPriceBreakdown } =
    useUnifiedPriceTagPriceBreakdownController();
  const routeName = useRouteName();

  if (!priceBreakdownTrigger) {
    return;
  }

  const handlePriceBreakdownClick = (e: React.SyntheticEvent) => {
    if (!!priceBreakdownContent) {
      e.stopPropagation();
      if (!showPriceBreakdown) {
        setShowPriceBreakdown(true);
        priceBreakdownOnOpen();
      }
    }
  };

  /* start - flights_lve_web_price_strikethrough_alignment */
  const isInPriceStrikethroughAlignmentExperiment =
    flights_lve_web_price_strikethrough_alignment.trackWithDefaultStage() > 0;
  const priceStrikethroughIconAsButton = (
    <Button
      variant="tertiary-neutral"
      size="medium"
      {...priceBreakdownTriggerProps}
      onClick={handlePriceBreakdownClick}
    >
      {priceBreakdownTrigger}
    </Button>
  );
  /* end - flights_lve_web_price_strikethrough_alignment */

  return (
    <>
      {isInPriceStrikethroughAlignmentExperiment && routeName.includes("flightdetails") ? (
        priceStrikethroughIconAsButton
      ) : (
        <Actionable onClick={handlePriceBreakdownClick} {...priceBreakdownTriggerProps}>
          {priceBreakdownTrigger}
        </Actionable>
      )}
      {showPriceBreakdown && (
        <SheetContainer
          onCloseTrigger={() => {
            setShowPriceBreakdown(false);
            priceBreakdownOnClose();
          }}
          title={contentTitle}
          closeAriaLabel={closeAriaLabel}
          active={true}
          attributes={{
            "data-testid": "upt_price_breakdown_content"
          }}
        >
          {priceBreakdownContent}
        </SheetContainer>
      )}
    </>
  );
};
